import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelGerman_ch: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'B',
  },
  {
    code: 6,
    label: 'C',
  },
  {
    code: 7,
    label: 'D',
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
  },
  {
    code: 10,
    label: 'G',
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
  },
  {
    code: 15,
    label: 'L',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'N',
  },
  {
    code: 18,
    label: 'O',
  },
  {
    code: 19,
    label: 'P',
  },
  {
    code: 20,
    label: 'Q',
  },
  {
    code: 21,
    label: 'R',
  },
  {
    code: 22,
    label: 'S',
  },
  {
    code: 23,
    label: 'T',
  },
  {
    code: 24,
    label: 'U',
  },
  {
    code: 25,
    label: 'V',
  },
  {
    code: 26,
    label: 'W',
  },
  {
    code: 27,
    label: 'X',
  },
  {
    code: 28,
    label: 'Z',
  },
  {
    code: 29,
    label: 'Y',
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¦',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: 'ç',
        modifiers: MOD.SFT,
      },
      {
        label: 'ç',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '/',
        modifiers: MOD.SFT,
      },
      {
        label: '/',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: '=',
        modifiers: MOD.SFT,
      },
      {
        label: '=',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: "'",
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '^ (dead)',
    meta: [
      {
        label: '` (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'ü',
    meta: [
      {
        label: 'è',
        modifiers: MOD.SFT,
      },
      {
        label: 'è',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: '¨ (dead)',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: '$',
    meta: [
      {
        label: '£',
        modifiers: MOD.SFT,
      },
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'ö',
    meta: [
      {
        label: 'é',
        modifiers: MOD.SFT,
      },
      {
        label: 'é',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 52,
    label: 'ä',
    meta: [
      {
        label: 'à',
        modifiers: MOD.SFT,
      },
      {
        label: 'à',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '§',
    meta: [
      {
        label: '°',
        modifiers: MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: ';',
        modifiers: MOD.SFT,
      },
      {
        label: ';',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 542,
    label: '+',
  },
  {
    code: 543,
    label: '"',
  },
  {
    code: 544,
    label: '*',
  },
  {
    code: 545,
    label: 'ç',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '&',
  },
  {
    code: 548,
    label: '/',
  },
  {
    code: 549,
    label: '(',
  },
  {
    code: 550,
    label: ')',
  },
  {
    code: 551,
    label: '=',
  },
  {
    code: 557,
    label: '?',
  },
  {
    code: 558,
    label: '` (dead)',
  },
  {
    code: 559,
    label: 'è',
  },
  {
    code: 560,
    label: '!',
  },
  {
    code: 562,
    label: '£',
  },
  {
    code: 563,
    label: 'é',
  },
  {
    code: 564,
    label: 'à',
  },
  {
    code: 565,
    label: '°',
  },
  {
    code: 566,
    label: ';',
  },
  {
    code: 567,
    label: ':',
  },
  {
    code: 568,
    label: '_',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 4638,
    label: '+',
  },
  {
    code: 4639,
    label: '"',
  },
  {
    code: 4640,
    label: '*',
  },
  {
    code: 4641,
    label: 'ç',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '&',
  },
  {
    code: 4644,
    label: '/',
  },
  {
    code: 4645,
    label: '(',
  },
  {
    code: 4646,
    label: ')',
  },
  {
    code: 4647,
    label: '=',
  },
  {
    code: 4653,
    label: '?',
  },
  {
    code: 4654,
    label: '` (dead)',
  },
  {
    code: 4655,
    label: 'è',
  },
  {
    code: 4656,
    label: '!',
  },
  {
    code: 4658,
    label: '£',
  },
  {
    code: 4659,
    label: 'é',
  },
  {
    code: 4660,
    label: 'à',
  },
  {
    code: 4661,
    label: '°',
  },
  {
    code: 4662,
    label: ';',
  },
  {
    code: 4663,
    label: ':',
  },
  {
    code: 4664,
    label: '_',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5150,
    label: '¦',
  },
  {
    code: 5151,
    label: '@',
  },
  {
    code: 5152,
    label: '#',
  },
  {
    code: 5155,
    label: '¬',
  },
  {
    code: 5156,
    label: '|',
  },
  {
    code: 5157,
    label: '¢',
  },
  {
    code: 5165,
    label: '´ (dead)',
  },
  {
    code: 5166,
    label: '~ (dead)',
  },
  {
    code: 5167,
    label: '[',
  },
  {
    code: 5168,
    label: ']',
  },
  {
    code: 5170,
    label: '}',
  },
  {
    code: 5172,
    label: '{',
  },
  {
    code: 5220,
    label: '(backslash)',
  },
];
